import React, { useState } from "react";
import { Box, Grid, Paper, Typography } from "@material-ui/core";
import {
  FormActionDrawer,
  IntroText,
  LogoVaxYes,
  Sheet,
  SheetContent
} from "../../../components";
import { useTranslation } from "react-i18next";
import { Redirect, useHistory, useLocation } from "react-router";
import { ROUTE_PATHS } from "../../../constants";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon
} from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

const SHARE_URL = "https://gogetdoc.com/vaxyes";
const SHARE_TEXT =
  "Get your free, secure, verified vaccine passport on your phone.";

const VaxYesRegisterSuccess = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { state = {} } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const [drawerClearance, setDrawerClearance] = useState(0);

  const handleNext = () => history.push("/");

  if (!state.first_name)
    return <Redirect to={ROUTE_PATHS.VAXYES.REGISTER_BASE} />;

  return (
    <Sheet
      data-cy="vax-yes-register-view"
      style={{ paddingBottom: `${drawerClearance}px` }}
    >
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <Box textAlign="center" mb={2}>
                <LogoVaxYes height="50px" />
              </Box>
              <IntroText>
                {t("vax_yes.vax_yes_register_success.intro_text", {
                  first_name: state.first_name
                })}
              </IntroText>
              <Box textAlign="center">
                <Typography paragraph>
                  {t("vax_yes.vax_yes_register_success.secondary_text")}
                </Typography>
                <Typography gutterBottom>
                  {t("vax_yes.vax_yes_register_success.share_text")}
                </Typography>
                <Box my={2}>
                  <CopyToClipboard
                    text={SHARE_URL}
                    onCopy={() =>
                      enqueueSnackbar("Copied", { variant: "info" })
                    }
                  >
                    <Grid
                      container
                      spacing={1}
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <FileCopyOutlinedIcon fontSize="small" />
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">
                          <strong>{SHARE_URL}</strong>
                        </Typography>
                      </Grid>
                    </Grid>
                  </CopyToClipboard>
                </Box>
                <Typography gutterBottom>
                  {t("vax_yes.vax_yes_register_success.share_link_text")}
                </Typography>
              </Box>
              <Grid container spacing={1} justify="center">
                <Grid item>
                  <FacebookShareButton url={SHARE_URL} quote={SHARE_TEXT}>
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                </Grid>
                <Grid item>
                  <TwitterShareButton url={SHARE_URL} title={SHARE_TEXT}>
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                </Grid>
                <Grid item>
                  <LinkedinShareButton url={SHARE_URL} title={SHARE_TEXT}>
                    <LinkedinIcon size={32} round />
                  </LinkedinShareButton>
                </Grid>
              </Grid>

              <FormActionDrawer
                handleNext={() => handleNext()}
                setDrawerClearance={setDrawerClearance}
                nextButtonLabel={t(
                  "vax_yes.vax_yes_register_success.button_next"
                )}
              />
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { VaxYesRegisterSuccess };
